import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { ModalService } from '@app/core/services/modal.service';
import { ToastService } from '@app/core/services/toast.service';
import { DemonstrationService } from '@app/configure/services/demonstration.service';

import { Modal } from '@app/core/models/modal.model';
import { ModalAction } from '@app/core/models/modal-action.model';

@Component({
	selector: 'cng-demo-finance-update-modal',
	templateUrl: './demo-finance-update.component.html',
	styleUrls: ['./demo-finance-update.component.less'],
})
export class DemoFinanceUpdateModalComponent implements OnInit {
	quote: any;
	reference: any;
	options_form: FormGroup;

	update_types: { value: string; name: string }[] = [
		{ value: 'approved', name: 'Approved' },
		{ value: 'rejected', name: 'Rejected' },
	];

	/**
	 * Construct the DemoFinanceUpdateModalComponent
	 *
	 * @param {ModalService} modal_service
	 * @param {DemonstrationService} demonstration_service
	 * @param {ToastService} toast_service
	 */
	constructor(
		private modal_service: ModalService,
		private demonstration_service: DemonstrationService,
		private toast_service: ToastService
	) {
		this.quote = this.modal_service.data.quote;
		this.reference = this.modal_service.data.quote.quote_UID;
		this.constructModal();
	}

	/**
	 * Construct the modal
	 */
	constructModal(): void {
		this.modal_service.setConfig(
			new Modal({
				name: 'finance_demo_modal',
				title: 'Finance Update Demonstration',
				actions: [
					new ModalAction({
						id: 'show',
						name: 'Trigger Update',
						bias: 'positive',
						large: true,
						showLoading: false,
						click: () => {
							this.onUpdate();
							this.modal_service.close();
							this.toast_service.success('Sending...');
						},
					}),
				],
			})
		);
	}

	/**
	 * Build the form when the component is initialized
	 */
	ngOnInit(): void {
		this.buildForm();
	}

	/**
	 * On the update of the demonstration send the type of update that is wanted.
	 */
	onUpdate(): void {
		setTimeout(() => {
			this.demonstration_service
				.sendDemonstrationUpdate({
					type: this.options_form.controls['update_type'].value,
					quote_reference: this.reference,
				})
				.subscribe();
		}, 5000);
	}

	/**
	 * Build the form
	 */
	buildForm(): void {
		this.options_form = new FormGroup({
			update_type: new FormControl(this.update_types[0].value),
		});
	}
}
